import { store } from "store/store";
import authActions from "./actions";

const setupTokenRefresh = () => {
  const refreshExpiration = () => {
    store.dispatch(authActions.refreshExpiration());
  };

  // Adiciona event listeners para atividades do usuário
  window.addEventListener("mousemove", refreshExpiration);
  window.addEventListener("keypress", refreshExpiration);
  window.addEventListener("scroll", refreshExpiration);

  // Remove os event listeners quando necessário (opcional)
  return () => {
    window.removeEventListener("mousemove", refreshExpiration);
    window.removeEventListener("keypress", refreshExpiration);
    window.removeEventListener("scroll", refreshExpiration);
  };
};

export default setupTokenRefresh;
